// This file is auto-generated by @hey-api/openapi-ts

import type { Options } from "@hey-api/client-fetch";
import { queryOptions, type UseMutationOptions } from "@tanstack/react-query";
import {
  client,
  getVersion,
  postCouponRedeem,
  postCouponCreateVideoAnnotationDaypass,
  postCouponCreateVideoAnnotationDaypassQr,
  getMachinesSearch,
  getMachinesSearchAura,
  getMachinesSearchTagging,
  getMachinesSearchRegionList,
  getMachinesSearchRegionListAura,
  postMachinesUpdateStatus,
  postMachinesUpdateGroupsByGroupByAction,
  postMachinesRegister,
  getMachinesByMachineUuidGames,
  postMachinesUpdateFieldImage,
  getMachinesByMachineUuidOwnerOrgs,
  postStripeWebhook,
  postLiveGrantWs,
  getHistoricRecent,
  postDataSensor,
  postDataSensorBackfill,
  postDataTag,
  postDataTeamSwap,
  postDataTeamSwapSmart,
  postDataNoTeamSwap,
  postDataNoTeamSwapSmart,
  getMe,
  postMe,
  postMeUpdateName,
  postMeDelete,
  getMeFeatures,
  getMeVisibilityGroupsTeams,
  getMeOrganizations,
  postJournal,
  postUserCreate,
  postUsersByUserIdEdit,
  getUsersInternal,
  postStripeCheckout,
  getReportsVisibilityGroups,
  getReportsPlayersSearch,
  getReportsSearch,
  getReportsDownload,
  getReportsDownloadRaw,
  getTeamsSearch,
  getTeamsTeamidSearch,
  getTeamsByTeamExternalIdTrends,
  postRostersByRosterIdDelete,
  postRostersByRosterIdEditName,
  postRostersByRosterIdEdit,
  postRostersByRosterIdRemovePlayerByPlayerExternalId,
  getPlayersSearch,
  getPlayersByPlayerExternalId,
  getPlayersByPlayerIdLatestGame,
  getPlayersByPlayerIdStats,
  getPlayersByPlayerExternalIdAvailablePitchTypes,
  getPlayersByPlayerExternalIdGamesData,
  getCompetitionLevelsByCompetitionLevelStats,
  postRostersUnofficialUpload,
  getRostersUnofficialDownload,
  postGameStart,
  getGameActive,
  postGameActiveLineups,
  postGameByGameIdSubstitute,
  postGameByGameIdEnd,
  postGameByGameIdEditTimes,
  getGameByGameIdCsv,
  getGameByGameIdEvents,
  postGameByGameIdReport,
  getOrganizationsByOrgIdUsers,
  getOrganizationsByOrgIdMachines,
  getOrganizationsByOrgIdOfficialTeam,
  postOrganizationsByOrgIdAssociateMachines,
  postOrganizationsByOrgIdAssociateOfficialTeams,
  postOrganizationsByOrgIdDelete,
  postOrganizationsByOrgIdVerify,
  getOrganizationsSearch,
  getOrganizations,
  postOrganizationsCreate,
  postOrganizationsByOrgIdEdit,
  getOrganizationsByOrgIdBillingPaymentMethod,
  postOrganizationsByOrgIdBillingPaymentMethod,
  postOrganizationsByOrgIdBillingSetupIntent,
  postOrganizationsByOrgIdPlayersByPlayerIdDelete,
  postUsersInvitationsCreate,
  getUsersInvitationsByTokenCode,
  postUsersInvitationsByTokenCodeRedeem,
  getInvitationsOrganizationsUnverified,
  postRostersByRosterIdPlayers,
  postOrganizationsByOrgIdPlayersByPlayerExternalIdEdit,
  getAuthoritiesPublic,
  getTeamsByTeamExternalIdLeaderboard,
  postBalltrackerByMachineUuidChallenge,
  getBalltrackerByMachineUuidBlocked,
  postBalltrackerByMachineUuidBlocked,
  deleteBalltrackerByMachineUuidBlocked,
  getBalltrackerByMachineUuidStatTracking,
  postBalltrackerByMachineUuidStatTracking,
  deleteBalltrackerByMachineUuidStatTracking,
  getBalltrackerByMachineUuidUmpireAssist,
  postBalltrackerByMachineUuidUmpireAssist,
  deleteBalltrackerByMachineUuidUmpireAssist,
  getBalltrackerByMachineUuidUnified,
  postBalltrackerByMachineUuidUnified,
  getBalltrackerByMachineUuidStrikeZone,
  postBalltrackerByMachineUuidStrikeZone,
  getBalltrackerStrikeZoneBySport,
  getSchedule,
  getScheduleByScheduleUuid,
  postScheduleExternal,
  postScheduleInternal,
} from "../services.gen";
import type {
  PostCouponRedeemData,
  PostCouponRedeemError,
  PostCouponRedeemResponse,
  PostCouponCreateVideoAnnotationDaypassData,
  PostCouponCreateVideoAnnotationDaypassError,
  PostCouponCreateVideoAnnotationDaypassResponse,
  PostCouponCreateVideoAnnotationDaypassQrData,
  PostCouponCreateVideoAnnotationDaypassQrError,
  PostCouponCreateVideoAnnotationDaypassQrResponse,
  GetMachinesSearchData,
  GetMachinesSearchAuraData,
  GetMachinesSearchTaggingData,
  PostMachinesUpdateStatusData,
  PostMachinesUpdateStatusError,
  PostMachinesUpdateStatusResponse,
  PostMachinesUpdateGroupsByGroupByActionData,
  PostMachinesUpdateGroupsByGroupByActionError,
  PostMachinesUpdateGroupsByGroupByActionResponse,
  PostMachinesRegisterData,
  PostMachinesRegisterError,
  PostMachinesRegisterResponse,
  GetMachinesByMachineUuidGamesData,
  PostMachinesUpdateFieldImageData,
  PostMachinesUpdateFieldImageError,
  PostMachinesUpdateFieldImageResponse,
  GetMachinesByMachineUuidOwnerOrgsData,
  PostStripeWebhookData,
  PostStripeWebhookError,
  PostStripeWebhookResponse,
  PostLiveGrantWsData,
  PostLiveGrantWsError,
  PostLiveGrantWsResponse,
  GetHistoricRecentData,
  PostDataSensorData,
  PostDataSensorError,
  PostDataSensorResponse,
  PostDataSensorBackfillData,
  PostDataSensorBackfillError,
  PostDataSensorBackfillResponse,
  PostDataTagData,
  PostDataTagError,
  PostDataTagResponse,
  PostDataTeamSwapData,
  PostDataTeamSwapError,
  PostDataTeamSwapResponse,
  PostDataTeamSwapSmartData,
  PostDataTeamSwapSmartError,
  PostDataTeamSwapSmartResponse,
  PostDataNoTeamSwapData,
  PostDataNoTeamSwapError,
  PostDataNoTeamSwapResponse,
  PostDataNoTeamSwapSmartData,
  PostDataNoTeamSwapSmartError,
  PostDataNoTeamSwapSmartResponse,
  PostMeError,
  PostMeResponse,
  PostMeUpdateNameData,
  PostMeUpdateNameError,
  PostMeUpdateNameResponse,
  PostMeDeleteError,
  PostMeDeleteResponse,
  PostJournalData,
  PostJournalError,
  PostJournalResponse,
  PostUserCreateData,
  PostUserCreateError,
  PostUserCreateResponse,
  PostUsersByUserIdEditData,
  PostUsersByUserIdEditError,
  PostUsersByUserIdEditResponse,
  GetUsersInternalData,
  PostStripeCheckoutData,
  PostStripeCheckoutError,
  PostStripeCheckoutResponse,
  GetReportsPlayersSearchData,
  GetReportsSearchData,
  GetReportsDownloadData,
  GetReportsDownloadRawData,
  GetTeamsSearchData,
  GetTeamsTeamidSearchData,
  GetTeamsByTeamExternalIdTrendsData,
  PostRostersByRosterIdDeleteData,
  PostRostersByRosterIdDeleteError,
  PostRostersByRosterIdDeleteResponse,
  PostRostersByRosterIdEditNameData,
  PostRostersByRosterIdEditNameError,
  PostRostersByRosterIdEditNameResponse,
  PostRostersByRosterIdEditData,
  PostRostersByRosterIdEditError,
  PostRostersByRosterIdEditResponse,
  PostRostersByRosterIdRemovePlayerByPlayerExternalIdData,
  PostRostersByRosterIdRemovePlayerByPlayerExternalIdError,
  PostRostersByRosterIdRemovePlayerByPlayerExternalIdResponse,
  GetPlayersSearchData,
  GetPlayersByPlayerExternalIdData,
  GetPlayersByPlayerIdLatestGameData,
  GetPlayersByPlayerIdStatsData,
  GetPlayersByPlayerExternalIdAvailablePitchTypesData,
  GetPlayersByPlayerExternalIdGamesDataData,
  GetCompetitionLevelsByCompetitionLevelStatsData,
  PostRostersUnofficialUploadData,
  PostRostersUnofficialUploadError,
  PostRostersUnofficialUploadResponse,
  GetRostersUnofficialDownloadData,
  PostGameStartData,
  PostGameStartError,
  PostGameStartResponse,
  GetGameActiveData,
  PostGameActiveLineupsData,
  PostGameActiveLineupsError,
  PostGameActiveLineupsResponse,
  PostGameByGameIdSubstituteData,
  PostGameByGameIdSubstituteError,
  PostGameByGameIdSubstituteResponse,
  PostGameByGameIdEndData,
  PostGameByGameIdEndError,
  PostGameByGameIdEndResponse,
  PostGameByGameIdEditTimesData,
  PostGameByGameIdEditTimesError,
  PostGameByGameIdEditTimesResponse,
  GetGameByGameIdCsvData,
  GetGameByGameIdEventsData,
  PostGameByGameIdReportData,
  PostGameByGameIdReportError,
  PostGameByGameIdReportResponse,
  GetOrganizationsByOrgIdUsersData,
  GetOrganizationsByOrgIdMachinesData,
  GetOrganizationsByOrgIdOfficialTeamData,
  PostOrganizationsByOrgIdAssociateMachinesData,
  PostOrganizationsByOrgIdAssociateMachinesError,
  PostOrganizationsByOrgIdAssociateMachinesResponse,
  PostOrganizationsByOrgIdAssociateOfficialTeamsData,
  PostOrganizationsByOrgIdAssociateOfficialTeamsError,
  PostOrganizationsByOrgIdAssociateOfficialTeamsResponse,
  PostOrganizationsByOrgIdDeleteData,
  PostOrganizationsByOrgIdDeleteError,
  PostOrganizationsByOrgIdDeleteResponse,
  PostOrganizationsByOrgIdVerifyData,
  PostOrganizationsByOrgIdVerifyError,
  PostOrganizationsByOrgIdVerifyResponse,
  GetOrganizationsSearchData,
  PostOrganizationsCreateData,
  PostOrganizationsCreateError,
  PostOrganizationsCreateResponse,
  PostOrganizationsByOrgIdEditData,
  PostOrganizationsByOrgIdEditError,
  PostOrganizationsByOrgIdEditResponse,
  GetOrganizationsByOrgIdBillingPaymentMethodData,
  PostOrganizationsByOrgIdBillingPaymentMethodData,
  PostOrganizationsByOrgIdBillingPaymentMethodError,
  PostOrganizationsByOrgIdBillingPaymentMethodResponse,
  PostOrganizationsByOrgIdBillingSetupIntentData,
  PostOrganizationsByOrgIdBillingSetupIntentError,
  PostOrganizationsByOrgIdBillingSetupIntentResponse,
  PostOrganizationsByOrgIdPlayersByPlayerIdDeleteData,
  PostOrganizationsByOrgIdPlayersByPlayerIdDeleteError,
  PostOrganizationsByOrgIdPlayersByPlayerIdDeleteResponse,
  PostUsersInvitationsCreateData,
  PostUsersInvitationsCreateError,
  PostUsersInvitationsCreateResponse,
  GetUsersInvitationsByTokenCodeData,
  PostUsersInvitationsByTokenCodeRedeemData,
  PostUsersInvitationsByTokenCodeRedeemError,
  PostUsersInvitationsByTokenCodeRedeemResponse,
  PostRostersByRosterIdPlayersData,
  PostRostersByRosterIdPlayersError,
  PostRostersByRosterIdPlayersResponse,
  PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditData,
  PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditError,
  PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditResponse,
  GetTeamsByTeamExternalIdLeaderboardData,
  PostBalltrackerByMachineUuidChallengeData,
  PostBalltrackerByMachineUuidChallengeError,
  PostBalltrackerByMachineUuidChallengeResponse,
  GetBalltrackerByMachineUuidBlockedData,
  PostBalltrackerByMachineUuidBlockedData,
  PostBalltrackerByMachineUuidBlockedError,
  PostBalltrackerByMachineUuidBlockedResponse,
  DeleteBalltrackerByMachineUuidBlockedData,
  DeleteBalltrackerByMachineUuidBlockedError,
  DeleteBalltrackerByMachineUuidBlockedResponse,
  GetBalltrackerByMachineUuidStatTrackingData,
  PostBalltrackerByMachineUuidStatTrackingData,
  PostBalltrackerByMachineUuidStatTrackingError,
  PostBalltrackerByMachineUuidStatTrackingResponse,
  DeleteBalltrackerByMachineUuidStatTrackingData,
  DeleteBalltrackerByMachineUuidStatTrackingError,
  DeleteBalltrackerByMachineUuidStatTrackingResponse,
  GetBalltrackerByMachineUuidUmpireAssistData,
  PostBalltrackerByMachineUuidUmpireAssistData,
  PostBalltrackerByMachineUuidUmpireAssistError,
  PostBalltrackerByMachineUuidUmpireAssistResponse,
  DeleteBalltrackerByMachineUuidUmpireAssistData,
  DeleteBalltrackerByMachineUuidUmpireAssistError,
  DeleteBalltrackerByMachineUuidUmpireAssistResponse,
  GetBalltrackerByMachineUuidUnifiedData,
  PostBalltrackerByMachineUuidUnifiedData,
  PostBalltrackerByMachineUuidUnifiedError,
  PostBalltrackerByMachineUuidUnifiedResponse,
  GetBalltrackerByMachineUuidStrikeZoneData,
  PostBalltrackerByMachineUuidStrikeZoneData,
  PostBalltrackerByMachineUuidStrikeZoneError,
  PostBalltrackerByMachineUuidStrikeZoneResponse,
  GetBalltrackerStrikeZoneBySportData,
  GetScheduleData,
  GetScheduleByScheduleUuidData,
  PostScheduleExternalData,
  PostScheduleExternalError,
  PostScheduleExternalResponse,
  PostScheduleInternalData,
  PostScheduleInternalError,
  PostScheduleInternalResponse,
} from "../types.gen";

type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string;
    _infinite?: boolean;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
): QueryKey<TOptions>[0] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return params;
};

export const getVersionQueryKey = (options?: Options) => [
  createQueryKey("getVersion", options),
];

export const getVersionOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getVersion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getVersionQueryKey(options),
  });
};

export const postCouponRedeemQueryKey = (
  options: Options<PostCouponRedeemData>,
) => [createQueryKey("postCouponRedeem", options)];

export const postCouponRedeemOptions = (
  options: Options<PostCouponRedeemData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postCouponRedeem({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postCouponRedeemQueryKey(options),
  });
};

export const postCouponRedeemMutation = (
  options?: Partial<Options<PostCouponRedeemData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostCouponRedeemResponse,
    PostCouponRedeemError,
    Options<PostCouponRedeemData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postCouponRedeem({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postCouponCreateVideoAnnotationDaypassQueryKey = (
  options?: Options<PostCouponCreateVideoAnnotationDaypassData>,
) => [createQueryKey("postCouponCreateVideoAnnotationDaypass", options)];

export const postCouponCreateVideoAnnotationDaypassOptions = (
  options?: Options<PostCouponCreateVideoAnnotationDaypassData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postCouponCreateVideoAnnotationDaypass({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postCouponCreateVideoAnnotationDaypassQueryKey(options),
  });
};

export const postCouponCreateVideoAnnotationDaypassMutation = (
  options?: Partial<Options<PostCouponCreateVideoAnnotationDaypassData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostCouponCreateVideoAnnotationDaypassResponse,
    PostCouponCreateVideoAnnotationDaypassError,
    Options<PostCouponCreateVideoAnnotationDaypassData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postCouponCreateVideoAnnotationDaypass({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postCouponCreateVideoAnnotationDaypassQrQueryKey = (
  options?: Options<PostCouponCreateVideoAnnotationDaypassQrData>,
) => [createQueryKey("postCouponCreateVideoAnnotationDaypassQr", options)];

export const postCouponCreateVideoAnnotationDaypassQrOptions = (
  options?: Options<PostCouponCreateVideoAnnotationDaypassQrData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postCouponCreateVideoAnnotationDaypassQr({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postCouponCreateVideoAnnotationDaypassQrQueryKey(options),
  });
};

export const postCouponCreateVideoAnnotationDaypassQrMutation = (
  options?: Partial<Options<PostCouponCreateVideoAnnotationDaypassQrData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostCouponCreateVideoAnnotationDaypassQrResponse,
    PostCouponCreateVideoAnnotationDaypassQrError,
    Options<PostCouponCreateVideoAnnotationDaypassQrData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postCouponCreateVideoAnnotationDaypassQr({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMachinesSearchQueryKey = (
  options?: Options<GetMachinesSearchData>,
) => [createQueryKey("getMachinesSearch", options)];

export const getMachinesSearchOptions = (
  options?: Options<GetMachinesSearchData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMachinesSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMachinesSearchQueryKey(options),
  });
};

export const getMachinesSearchAuraQueryKey = (
  options?: Options<GetMachinesSearchAuraData>,
) => [createQueryKey("getMachinesSearchAura", options)];

export const getMachinesSearchAuraOptions = (
  options?: Options<GetMachinesSearchAuraData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMachinesSearchAura({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMachinesSearchAuraQueryKey(options),
  });
};

export const getMachinesSearchTaggingQueryKey = (
  options?: Options<GetMachinesSearchTaggingData>,
) => [createQueryKey("getMachinesSearchTagging", options)];

export const getMachinesSearchTaggingOptions = (
  options?: Options<GetMachinesSearchTaggingData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMachinesSearchTagging({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMachinesSearchTaggingQueryKey(options),
  });
};

export const getMachinesSearchRegionListQueryKey = (options?: Options) => [
  createQueryKey("getMachinesSearchRegionList", options),
];

export const getMachinesSearchRegionListOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMachinesSearchRegionList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMachinesSearchRegionListQueryKey(options),
  });
};

export const getMachinesSearchRegionListAuraQueryKey = (options?: Options) => [
  createQueryKey("getMachinesSearchRegionListAura", options),
];

export const getMachinesSearchRegionListAuraOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMachinesSearchRegionListAura({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMachinesSearchRegionListAuraQueryKey(options),
  });
};

export const postMachinesUpdateStatusQueryKey = (
  options: Options<PostMachinesUpdateStatusData>,
) => [createQueryKey("postMachinesUpdateStatus", options)];

export const postMachinesUpdateStatusOptions = (
  options: Options<PostMachinesUpdateStatusData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postMachinesUpdateStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postMachinesUpdateStatusQueryKey(options),
  });
};

export const postMachinesUpdateStatusMutation = (
  options?: Partial<Options<PostMachinesUpdateStatusData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostMachinesUpdateStatusResponse,
    PostMachinesUpdateStatusError,
    Options<PostMachinesUpdateStatusData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postMachinesUpdateStatus({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postMachinesUpdateGroupsByGroupByActionQueryKey = (
  options: Options<PostMachinesUpdateGroupsByGroupByActionData>,
) => [createQueryKey("postMachinesUpdateGroupsByGroupByAction", options)];

export const postMachinesUpdateGroupsByGroupByActionOptions = (
  options: Options<PostMachinesUpdateGroupsByGroupByActionData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postMachinesUpdateGroupsByGroupByAction({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postMachinesUpdateGroupsByGroupByActionQueryKey(options),
  });
};

export const postMachinesUpdateGroupsByGroupByActionMutation = (
  options?: Partial<Options<PostMachinesUpdateGroupsByGroupByActionData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostMachinesUpdateGroupsByGroupByActionResponse,
    PostMachinesUpdateGroupsByGroupByActionError,
    Options<PostMachinesUpdateGroupsByGroupByActionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postMachinesUpdateGroupsByGroupByAction({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postMachinesRegisterQueryKey = (
  options: Options<PostMachinesRegisterData>,
) => [createQueryKey("postMachinesRegister", options)];

export const postMachinesRegisterOptions = (
  options: Options<PostMachinesRegisterData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postMachinesRegister({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postMachinesRegisterQueryKey(options),
  });
};

export const postMachinesRegisterMutation = (
  options?: Partial<Options<PostMachinesRegisterData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostMachinesRegisterResponse,
    PostMachinesRegisterError,
    Options<PostMachinesRegisterData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postMachinesRegister({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMachinesByMachineUuidGamesQueryKey = (
  options: Options<GetMachinesByMachineUuidGamesData>,
) => [createQueryKey("getMachinesByMachineUuidGames", options)];

export const getMachinesByMachineUuidGamesOptions = (
  options: Options<GetMachinesByMachineUuidGamesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMachinesByMachineUuidGames({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMachinesByMachineUuidGamesQueryKey(options),
  });
};

export const postMachinesUpdateFieldImageQueryKey = (
  options: Options<PostMachinesUpdateFieldImageData>,
) => [createQueryKey("postMachinesUpdateFieldImage", options)];

export const postMachinesUpdateFieldImageOptions = (
  options: Options<PostMachinesUpdateFieldImageData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postMachinesUpdateFieldImage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postMachinesUpdateFieldImageQueryKey(options),
  });
};

export const postMachinesUpdateFieldImageMutation = (
  options?: Partial<Options<PostMachinesUpdateFieldImageData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostMachinesUpdateFieldImageResponse,
    PostMachinesUpdateFieldImageError,
    Options<PostMachinesUpdateFieldImageData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postMachinesUpdateFieldImage({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMachinesByMachineUuidOwnerOrgsQueryKey = (
  options: Options<GetMachinesByMachineUuidOwnerOrgsData>,
) => [createQueryKey("getMachinesByMachineUuidOwnerOrgs", options)];

export const getMachinesByMachineUuidOwnerOrgsOptions = (
  options: Options<GetMachinesByMachineUuidOwnerOrgsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMachinesByMachineUuidOwnerOrgs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMachinesByMachineUuidOwnerOrgsQueryKey(options),
  });
};

export const postStripeWebhookQueryKey = (
  options: Options<PostStripeWebhookData>,
) => [createQueryKey("postStripeWebhook", options)];

export const postStripeWebhookOptions = (
  options: Options<PostStripeWebhookData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postStripeWebhook({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postStripeWebhookQueryKey(options),
  });
};

export const postStripeWebhookMutation = (
  options?: Partial<Options<PostStripeWebhookData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostStripeWebhookResponse,
    PostStripeWebhookError,
    Options<PostStripeWebhookData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postStripeWebhook({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postLiveGrantWsQueryKey = (
  options: Options<PostLiveGrantWsData>,
) => [createQueryKey("postLiveGrantWs", options)];

export const postLiveGrantWsOptions = (
  options: Options<PostLiveGrantWsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postLiveGrantWs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postLiveGrantWsQueryKey(options),
  });
};

export const postLiveGrantWsMutation = (
  options?: Partial<Options<PostLiveGrantWsData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostLiveGrantWsResponse,
    PostLiveGrantWsError,
    Options<PostLiveGrantWsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postLiveGrantWs({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getHistoricRecentQueryKey = (
  options: Options<GetHistoricRecentData>,
) => [createQueryKey("getHistoricRecent", options)];

export const getHistoricRecentOptions = (
  options: Options<GetHistoricRecentData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHistoricRecent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHistoricRecentQueryKey(options),
  });
};

export const postDataSensorQueryKey = (
  options: Options<PostDataSensorData>,
) => [createQueryKey("postDataSensor", options)];

export const postDataSensorOptions = (options: Options<PostDataSensorData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postDataSensor({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postDataSensorQueryKey(options),
  });
};

export const postDataSensorMutation = (
  options?: Partial<Options<PostDataSensorData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostDataSensorResponse,
    PostDataSensorError,
    Options<PostDataSensorData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postDataSensor({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postDataSensorBackfillQueryKey = (
  options: Options<PostDataSensorBackfillData>,
) => [createQueryKey("postDataSensorBackfill", options)];

export const postDataSensorBackfillOptions = (
  options: Options<PostDataSensorBackfillData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postDataSensorBackfill({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postDataSensorBackfillQueryKey(options),
  });
};

export const postDataSensorBackfillMutation = (
  options?: Partial<Options<PostDataSensorBackfillData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostDataSensorBackfillResponse,
    PostDataSensorBackfillError,
    Options<PostDataSensorBackfillData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postDataSensorBackfill({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postDataTagQueryKey = (options: Options<PostDataTagData>) => [
  createQueryKey("postDataTag", options),
];

export const postDataTagOptions = (options: Options<PostDataTagData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postDataTag({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postDataTagQueryKey(options),
  });
};

export const postDataTagMutation = (
  options?: Partial<Options<PostDataTagData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostDataTagResponse,
    PostDataTagError,
    Options<PostDataTagData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postDataTag({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postDataTeamSwapQueryKey = (
  options: Options<PostDataTeamSwapData>,
) => [createQueryKey("postDataTeamSwap", options)];

export const postDataTeamSwapOptions = (
  options: Options<PostDataTeamSwapData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postDataTeamSwap({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postDataTeamSwapQueryKey(options),
  });
};

export const postDataTeamSwapMutation = (
  options?: Partial<Options<PostDataTeamSwapData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostDataTeamSwapResponse,
    PostDataTeamSwapError,
    Options<PostDataTeamSwapData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postDataTeamSwap({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postDataTeamSwapSmartQueryKey = (
  options: Options<PostDataTeamSwapSmartData>,
) => [createQueryKey("postDataTeamSwapSmart", options)];

export const postDataTeamSwapSmartOptions = (
  options: Options<PostDataTeamSwapSmartData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postDataTeamSwapSmart({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postDataTeamSwapSmartQueryKey(options),
  });
};

export const postDataTeamSwapSmartMutation = (
  options?: Partial<Options<PostDataTeamSwapSmartData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostDataTeamSwapSmartResponse,
    PostDataTeamSwapSmartError,
    Options<PostDataTeamSwapSmartData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postDataTeamSwapSmart({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postDataNoTeamSwapQueryKey = (
  options: Options<PostDataNoTeamSwapData>,
) => [createQueryKey("postDataNoTeamSwap", options)];

export const postDataNoTeamSwapOptions = (
  options: Options<PostDataNoTeamSwapData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postDataNoTeamSwap({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postDataNoTeamSwapQueryKey(options),
  });
};

export const postDataNoTeamSwapMutation = (
  options?: Partial<Options<PostDataNoTeamSwapData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostDataNoTeamSwapResponse,
    PostDataNoTeamSwapError,
    Options<PostDataNoTeamSwapData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postDataNoTeamSwap({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postDataNoTeamSwapSmartQueryKey = (
  options: Options<PostDataNoTeamSwapSmartData>,
) => [createQueryKey("postDataNoTeamSwapSmart", options)];

export const postDataNoTeamSwapSmartOptions = (
  options: Options<PostDataNoTeamSwapSmartData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postDataNoTeamSwapSmart({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postDataNoTeamSwapSmartQueryKey(options),
  });
};

export const postDataNoTeamSwapSmartMutation = (
  options?: Partial<Options<PostDataNoTeamSwapSmartData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostDataNoTeamSwapSmartResponse,
    PostDataNoTeamSwapSmartError,
    Options<PostDataNoTeamSwapSmartData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postDataNoTeamSwapSmart({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMeQueryKey = (options?: Options) => [
  createQueryKey("getMe", options),
];

export const getMeOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMe({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMeQueryKey(options),
  });
};

export const postMeQueryKey = (options?: Options) => [
  createQueryKey("postMe", options),
];

export const postMeOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postMe({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postMeQueryKey(options),
  });
};

export const postMeMutation = (options?: Partial<Options>) => {
  const mutationOptions: UseMutationOptions<
    PostMeResponse,
    PostMeError,
    Options
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postMe({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postMeUpdateNameQueryKey = (
  options: Options<PostMeUpdateNameData>,
) => [createQueryKey("postMeUpdateName", options)];

export const postMeUpdateNameOptions = (
  options: Options<PostMeUpdateNameData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postMeUpdateName({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postMeUpdateNameQueryKey(options),
  });
};

export const postMeUpdateNameMutation = (
  options?: Partial<Options<PostMeUpdateNameData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostMeUpdateNameResponse,
    PostMeUpdateNameError,
    Options<PostMeUpdateNameData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postMeUpdateName({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postMeDeleteQueryKey = (options?: Options) => [
  createQueryKey("postMeDelete", options),
];

export const postMeDeleteOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postMeDelete({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postMeDeleteQueryKey(options),
  });
};

export const postMeDeleteMutation = (options?: Partial<Options>) => {
  const mutationOptions: UseMutationOptions<
    PostMeDeleteResponse,
    PostMeDeleteError,
    Options
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postMeDelete({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMeFeaturesQueryKey = (options?: Options) => [
  createQueryKey("getMeFeatures", options),
];

export const getMeFeaturesOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMeFeatures({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMeFeaturesQueryKey(options),
  });
};

export const getMeVisibilityGroupsTeamsQueryKey = (options?: Options) => [
  createQueryKey("getMeVisibilityGroupsTeams", options),
];

export const getMeVisibilityGroupsTeamsOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMeVisibilityGroupsTeams({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMeVisibilityGroupsTeamsQueryKey(options),
  });
};

export const getMeOrganizationsQueryKey = (options?: Options) => [
  createQueryKey("getMeOrganizations", options),
];

export const getMeOrganizationsOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMeOrganizations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMeOrganizationsQueryKey(options),
  });
};

export const postJournalQueryKey = (options?: Options<PostJournalData>) => [
  createQueryKey("postJournal", options),
];

export const postJournalOptions = (options?: Options<PostJournalData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postJournal({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postJournalQueryKey(options),
  });
};

export const postJournalMutation = (
  options?: Partial<Options<PostJournalData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostJournalResponse,
    PostJournalError,
    Options<PostJournalData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postJournal({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postUserCreateQueryKey = (
  options: Options<PostUserCreateData>,
) => [createQueryKey("postUserCreate", options)];

export const postUserCreateOptions = (options: Options<PostUserCreateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postUserCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postUserCreateQueryKey(options),
  });
};

export const postUserCreateMutation = (
  options?: Partial<Options<PostUserCreateData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostUserCreateResponse,
    PostUserCreateError,
    Options<PostUserCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postUserCreate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postUsersByUserIdEditQueryKey = (
  options: Options<PostUsersByUserIdEditData>,
) => [createQueryKey("postUsersByUserIdEdit", options)];

export const postUsersByUserIdEditOptions = (
  options: Options<PostUsersByUserIdEditData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postUsersByUserIdEdit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postUsersByUserIdEditQueryKey(options),
  });
};

export const postUsersByUserIdEditMutation = (
  options?: Partial<Options<PostUsersByUserIdEditData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostUsersByUserIdEditResponse,
    PostUsersByUserIdEditError,
    Options<PostUsersByUserIdEditData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postUsersByUserIdEdit({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getUsersInternalQueryKey = (
  options?: Options<GetUsersInternalData>,
) => [createQueryKey("getUsersInternal", options)];

export const getUsersInternalOptions = (
  options?: Options<GetUsersInternalData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUsersInternal({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUsersInternalQueryKey(options),
  });
};

export const postStripeCheckoutQueryKey = (
  options?: Options<PostStripeCheckoutData>,
) => [createQueryKey("postStripeCheckout", options)];

export const postStripeCheckoutOptions = (
  options?: Options<PostStripeCheckoutData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postStripeCheckout({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postStripeCheckoutQueryKey(options),
  });
};

export const postStripeCheckoutMutation = (
  options?: Partial<Options<PostStripeCheckoutData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostStripeCheckoutResponse,
    PostStripeCheckoutError,
    Options<PostStripeCheckoutData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postStripeCheckout({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getReportsVisibilityGroupsQueryKey = (options?: Options) => [
  createQueryKey("getReportsVisibilityGroups", options),
];

export const getReportsVisibilityGroupsOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReportsVisibilityGroups({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getReportsVisibilityGroupsQueryKey(options),
  });
};

export const getReportsPlayersSearchQueryKey = (
  options: Options<GetReportsPlayersSearchData>,
) => [createQueryKey("getReportsPlayersSearch", options)];

export const getReportsPlayersSearchOptions = (
  options: Options<GetReportsPlayersSearchData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReportsPlayersSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getReportsPlayersSearchQueryKey(options),
  });
};

export const getReportsSearchQueryKey = (
  options: Options<GetReportsSearchData>,
) => [createQueryKey("getReportsSearch", options)];

export const getReportsSearchOptions = (
  options: Options<GetReportsSearchData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReportsSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getReportsSearchQueryKey(options),
  });
};

export const getReportsDownloadQueryKey = (
  options: Options<GetReportsDownloadData>,
) => [createQueryKey("getReportsDownload", options)];

export const getReportsDownloadOptions = (
  options: Options<GetReportsDownloadData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReportsDownload({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getReportsDownloadQueryKey(options),
  });
};

export const getReportsDownloadRawQueryKey = (
  options: Options<GetReportsDownloadRawData>,
) => [createQueryKey("getReportsDownloadRaw", options)];

export const getReportsDownloadRawOptions = (
  options: Options<GetReportsDownloadRawData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReportsDownloadRaw({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getReportsDownloadRawQueryKey(options),
  });
};

export const getTeamsSearchQueryKey = (
  options: Options<GetTeamsSearchData>,
) => [createQueryKey("getTeamsSearch", options)];

export const getTeamsSearchOptions = (options: Options<GetTeamsSearchData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTeamsSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTeamsSearchQueryKey(options),
  });
};

export const getTeamsTeamidSearchQueryKey = (
  options: Options<GetTeamsTeamidSearchData>,
) => [createQueryKey("getTeamsTeamidSearch", options)];

export const getTeamsTeamidSearchOptions = (
  options: Options<GetTeamsTeamidSearchData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTeamsTeamidSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTeamsTeamidSearchQueryKey(options),
  });
};

export const getTeamsByTeamExternalIdTrendsQueryKey = (
  options: Options<GetTeamsByTeamExternalIdTrendsData>,
) => [createQueryKey("getTeamsByTeamExternalIdTrends", options)];

export const getTeamsByTeamExternalIdTrendsOptions = (
  options: Options<GetTeamsByTeamExternalIdTrendsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTeamsByTeamExternalIdTrends({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTeamsByTeamExternalIdTrendsQueryKey(options),
  });
};

export const postRostersByRosterIdDeleteQueryKey = (
  options: Options<PostRostersByRosterIdDeleteData>,
) => [createQueryKey("postRostersByRosterIdDelete", options)];

export const postRostersByRosterIdDeleteOptions = (
  options: Options<PostRostersByRosterIdDeleteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postRostersByRosterIdDelete({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postRostersByRosterIdDeleteQueryKey(options),
  });
};

export const postRostersByRosterIdDeleteMutation = (
  options?: Partial<Options<PostRostersByRosterIdDeleteData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostRostersByRosterIdDeleteResponse,
    PostRostersByRosterIdDeleteError,
    Options<PostRostersByRosterIdDeleteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postRostersByRosterIdDelete({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postRostersByRosterIdEditNameQueryKey = (
  options: Options<PostRostersByRosterIdEditNameData>,
) => [createQueryKey("postRostersByRosterIdEditName", options)];

export const postRostersByRosterIdEditNameOptions = (
  options: Options<PostRostersByRosterIdEditNameData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postRostersByRosterIdEditName({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postRostersByRosterIdEditNameQueryKey(options),
  });
};

export const postRostersByRosterIdEditNameMutation = (
  options?: Partial<Options<PostRostersByRosterIdEditNameData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostRostersByRosterIdEditNameResponse,
    PostRostersByRosterIdEditNameError,
    Options<PostRostersByRosterIdEditNameData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postRostersByRosterIdEditName({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postRostersByRosterIdEditQueryKey = (
  options: Options<PostRostersByRosterIdEditData>,
) => [createQueryKey("postRostersByRosterIdEdit", options)];

export const postRostersByRosterIdEditOptions = (
  options: Options<PostRostersByRosterIdEditData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postRostersByRosterIdEdit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postRostersByRosterIdEditQueryKey(options),
  });
};

export const postRostersByRosterIdEditMutation = (
  options?: Partial<Options<PostRostersByRosterIdEditData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostRostersByRosterIdEditResponse,
    PostRostersByRosterIdEditError,
    Options<PostRostersByRosterIdEditData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postRostersByRosterIdEdit({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postRostersByRosterIdRemovePlayerByPlayerExternalIdQueryKey = (
  options: Options<PostRostersByRosterIdRemovePlayerByPlayerExternalIdData>,
) => [
  createQueryKey(
    "postRostersByRosterIdRemovePlayerByPlayerExternalId",
    options,
  ),
];

export const postRostersByRosterIdRemovePlayerByPlayerExternalIdOptions = (
  options: Options<PostRostersByRosterIdRemovePlayerByPlayerExternalIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await postRostersByRosterIdRemovePlayerByPlayerExternalId({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      postRostersByRosterIdRemovePlayerByPlayerExternalIdQueryKey(options),
  });
};

export const postRostersByRosterIdRemovePlayerByPlayerExternalIdMutation = (
  options?: Partial<
    Options<PostRostersByRosterIdRemovePlayerByPlayerExternalIdData>
  >,
) => {
  const mutationOptions: UseMutationOptions<
    PostRostersByRosterIdRemovePlayerByPlayerExternalIdResponse,
    PostRostersByRosterIdRemovePlayerByPlayerExternalIdError,
    Options<PostRostersByRosterIdRemovePlayerByPlayerExternalIdData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } =
        await postRostersByRosterIdRemovePlayerByPlayerExternalId({
          ...options,
          ...localOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const getPlayersSearchQueryKey = (
  options: Options<GetPlayersSearchData>,
) => [createQueryKey("getPlayersSearch", options)];

export const getPlayersSearchOptions = (
  options: Options<GetPlayersSearchData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPlayersSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPlayersSearchQueryKey(options),
  });
};

export const getPlayersByPlayerExternalIdQueryKey = (
  options: Options<GetPlayersByPlayerExternalIdData>,
) => [createQueryKey("getPlayersByPlayerExternalId", options)];

export const getPlayersByPlayerExternalIdOptions = (
  options: Options<GetPlayersByPlayerExternalIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPlayersByPlayerExternalId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPlayersByPlayerExternalIdQueryKey(options),
  });
};

export const getPlayersByPlayerIdLatestGameQueryKey = (
  options: Options<GetPlayersByPlayerIdLatestGameData>,
) => [createQueryKey("getPlayersByPlayerIdLatestGame", options)];

export const getPlayersByPlayerIdLatestGameOptions = (
  options: Options<GetPlayersByPlayerIdLatestGameData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPlayersByPlayerIdLatestGame({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPlayersByPlayerIdLatestGameQueryKey(options),
  });
};

export const getPlayersByPlayerIdStatsQueryKey = (
  options: Options<GetPlayersByPlayerIdStatsData>,
) => [createQueryKey("getPlayersByPlayerIdStats", options)];

export const getPlayersByPlayerIdStatsOptions = (
  options: Options<GetPlayersByPlayerIdStatsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPlayersByPlayerIdStats({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPlayersByPlayerIdStatsQueryKey(options),
  });
};

export const getPlayersByPlayerExternalIdAvailablePitchTypesQueryKey = (
  options: Options<GetPlayersByPlayerExternalIdAvailablePitchTypesData>,
) => [
  createQueryKey("getPlayersByPlayerExternalIdAvailablePitchTypes", options),
];

export const getPlayersByPlayerExternalIdAvailablePitchTypesOptions = (
  options: Options<GetPlayersByPlayerExternalIdAvailablePitchTypesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPlayersByPlayerExternalIdAvailablePitchTypes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPlayersByPlayerExternalIdAvailablePitchTypesQueryKey(options),
  });
};

export const getPlayersByPlayerExternalIdGamesDataQueryKey = (
  options: Options<GetPlayersByPlayerExternalIdGamesDataData>,
) => [createQueryKey("getPlayersByPlayerExternalIdGamesData", options)];

export const getPlayersByPlayerExternalIdGamesDataOptions = (
  options: Options<GetPlayersByPlayerExternalIdGamesDataData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPlayersByPlayerExternalIdGamesData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPlayersByPlayerExternalIdGamesDataQueryKey(options),
  });
};

export const getCompetitionLevelsByCompetitionLevelStatsQueryKey = (
  options: Options<GetCompetitionLevelsByCompetitionLevelStatsData>,
) => [createQueryKey("getCompetitionLevelsByCompetitionLevelStats", options)];

export const getCompetitionLevelsByCompetitionLevelStatsOptions = (
  options: Options<GetCompetitionLevelsByCompetitionLevelStatsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCompetitionLevelsByCompetitionLevelStats({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCompetitionLevelsByCompetitionLevelStatsQueryKey(options),
  });
};

export const postRostersUnofficialUploadQueryKey = (
  options: Options<PostRostersUnofficialUploadData>,
) => [createQueryKey("postRostersUnofficialUpload", options)];

export const postRostersUnofficialUploadOptions = (
  options: Options<PostRostersUnofficialUploadData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postRostersUnofficialUpload({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postRostersUnofficialUploadQueryKey(options),
  });
};

export const postRostersUnofficialUploadMutation = (
  options?: Partial<Options<PostRostersUnofficialUploadData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostRostersUnofficialUploadResponse,
    PostRostersUnofficialUploadError,
    Options<PostRostersUnofficialUploadData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postRostersUnofficialUpload({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getRostersUnofficialDownloadQueryKey = (
  options: Options<GetRostersUnofficialDownloadData>,
) => [createQueryKey("getRostersUnofficialDownload", options)];

export const getRostersUnofficialDownloadOptions = (
  options: Options<GetRostersUnofficialDownloadData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRostersUnofficialDownload({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRostersUnofficialDownloadQueryKey(options),
  });
};

export const postGameStartQueryKey = (options: Options<PostGameStartData>) => [
  createQueryKey("postGameStart", options),
];

export const postGameStartOptions = (options: Options<PostGameStartData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postGameStart({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postGameStartQueryKey(options),
  });
};

export const postGameStartMutation = (
  options?: Partial<Options<PostGameStartData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostGameStartResponse,
    PostGameStartError,
    Options<PostGameStartData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postGameStart({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getGameActiveQueryKey = (options: Options<GetGameActiveData>) => [
  createQueryKey("getGameActive", options),
];

export const getGameActiveOptions = (options: Options<GetGameActiveData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGameActive({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGameActiveQueryKey(options),
  });
};

export const postGameActiveLineupsQueryKey = (
  options: Options<PostGameActiveLineupsData>,
) => [createQueryKey("postGameActiveLineups", options)];

export const postGameActiveLineupsOptions = (
  options: Options<PostGameActiveLineupsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postGameActiveLineups({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postGameActiveLineupsQueryKey(options),
  });
};

export const postGameActiveLineupsMutation = (
  options?: Partial<Options<PostGameActiveLineupsData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostGameActiveLineupsResponse,
    PostGameActiveLineupsError,
    Options<PostGameActiveLineupsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postGameActiveLineups({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postGameByGameIdSubstituteQueryKey = (
  options: Options<PostGameByGameIdSubstituteData>,
) => [createQueryKey("postGameByGameIdSubstitute", options)];

export const postGameByGameIdSubstituteOptions = (
  options: Options<PostGameByGameIdSubstituteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postGameByGameIdSubstitute({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postGameByGameIdSubstituteQueryKey(options),
  });
};

export const postGameByGameIdSubstituteMutation = (
  options?: Partial<Options<PostGameByGameIdSubstituteData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostGameByGameIdSubstituteResponse,
    PostGameByGameIdSubstituteError,
    Options<PostGameByGameIdSubstituteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postGameByGameIdSubstitute({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postGameByGameIdEndQueryKey = (
  options: Options<PostGameByGameIdEndData>,
) => [createQueryKey("postGameByGameIdEnd", options)];

export const postGameByGameIdEndOptions = (
  options: Options<PostGameByGameIdEndData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postGameByGameIdEnd({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postGameByGameIdEndQueryKey(options),
  });
};

export const postGameByGameIdEndMutation = (
  options?: Partial<Options<PostGameByGameIdEndData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostGameByGameIdEndResponse,
    PostGameByGameIdEndError,
    Options<PostGameByGameIdEndData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postGameByGameIdEnd({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postGameByGameIdEditTimesQueryKey = (
  options: Options<PostGameByGameIdEditTimesData>,
) => [createQueryKey("postGameByGameIdEditTimes", options)];

export const postGameByGameIdEditTimesOptions = (
  options: Options<PostGameByGameIdEditTimesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postGameByGameIdEditTimes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postGameByGameIdEditTimesQueryKey(options),
  });
};

export const postGameByGameIdEditTimesMutation = (
  options?: Partial<Options<PostGameByGameIdEditTimesData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostGameByGameIdEditTimesResponse,
    PostGameByGameIdEditTimesError,
    Options<PostGameByGameIdEditTimesData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postGameByGameIdEditTimes({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getGameByGameIdCsvQueryKey = (
  options: Options<GetGameByGameIdCsvData>,
) => [createQueryKey("getGameByGameIdCsv", options)];

export const getGameByGameIdCsvOptions = (
  options: Options<GetGameByGameIdCsvData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGameByGameIdCsv({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGameByGameIdCsvQueryKey(options),
  });
};

export const getGameByGameIdEventsQueryKey = (
  options: Options<GetGameByGameIdEventsData>,
) => [createQueryKey("getGameByGameIdEvents", options)];

export const getGameByGameIdEventsOptions = (
  options: Options<GetGameByGameIdEventsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGameByGameIdEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getGameByGameIdEventsQueryKey(options),
  });
};

export const postGameByGameIdReportQueryKey = (
  options: Options<PostGameByGameIdReportData>,
) => [createQueryKey("postGameByGameIdReport", options)];

export const postGameByGameIdReportOptions = (
  options: Options<PostGameByGameIdReportData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postGameByGameIdReport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postGameByGameIdReportQueryKey(options),
  });
};

export const postGameByGameIdReportMutation = (
  options?: Partial<Options<PostGameByGameIdReportData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostGameByGameIdReportResponse,
    PostGameByGameIdReportError,
    Options<PostGameByGameIdReportData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postGameByGameIdReport({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrganizationsByOrgIdUsersQueryKey = (
  options: Options<GetOrganizationsByOrgIdUsersData>,
) => [createQueryKey("getOrganizationsByOrgIdUsers", options)];

export const getOrganizationsByOrgIdUsersOptions = (
  options: Options<GetOrganizationsByOrgIdUsersData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationsByOrgIdUsers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrganizationsByOrgIdUsersQueryKey(options),
  });
};

export const getOrganizationsByOrgIdMachinesQueryKey = (
  options: Options<GetOrganizationsByOrgIdMachinesData>,
) => [createQueryKey("getOrganizationsByOrgIdMachines", options)];

export const getOrganizationsByOrgIdMachinesOptions = (
  options: Options<GetOrganizationsByOrgIdMachinesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationsByOrgIdMachines({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrganizationsByOrgIdMachinesQueryKey(options),
  });
};

export const getOrganizationsByOrgIdOfficialTeamQueryKey = (
  options: Options<GetOrganizationsByOrgIdOfficialTeamData>,
) => [createQueryKey("getOrganizationsByOrgIdOfficialTeam", options)];

export const getOrganizationsByOrgIdOfficialTeamOptions = (
  options: Options<GetOrganizationsByOrgIdOfficialTeamData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationsByOrgIdOfficialTeam({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrganizationsByOrgIdOfficialTeamQueryKey(options),
  });
};

export const postOrganizationsByOrgIdAssociateMachinesQueryKey = (
  options: Options<PostOrganizationsByOrgIdAssociateMachinesData>,
) => [createQueryKey("postOrganizationsByOrgIdAssociateMachines", options)];

export const postOrganizationsByOrgIdAssociateMachinesOptions = (
  options: Options<PostOrganizationsByOrgIdAssociateMachinesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrganizationsByOrgIdAssociateMachines({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrganizationsByOrgIdAssociateMachinesQueryKey(options),
  });
};

export const postOrganizationsByOrgIdAssociateMachinesMutation = (
  options?: Partial<Options<PostOrganizationsByOrgIdAssociateMachinesData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostOrganizationsByOrgIdAssociateMachinesResponse,
    PostOrganizationsByOrgIdAssociateMachinesError,
    Options<PostOrganizationsByOrgIdAssociateMachinesData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postOrganizationsByOrgIdAssociateMachines({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrganizationsByOrgIdAssociateOfficialTeamsQueryKey = (
  options: Options<PostOrganizationsByOrgIdAssociateOfficialTeamsData>,
) => [
  createQueryKey("postOrganizationsByOrgIdAssociateOfficialTeams", options),
];

export const postOrganizationsByOrgIdAssociateOfficialTeamsOptions = (
  options: Options<PostOrganizationsByOrgIdAssociateOfficialTeamsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrganizationsByOrgIdAssociateOfficialTeams({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrganizationsByOrgIdAssociateOfficialTeamsQueryKey(options),
  });
};

export const postOrganizationsByOrgIdAssociateOfficialTeamsMutation = (
  options?: Partial<
    Options<PostOrganizationsByOrgIdAssociateOfficialTeamsData>
  >,
) => {
  const mutationOptions: UseMutationOptions<
    PostOrganizationsByOrgIdAssociateOfficialTeamsResponse,
    PostOrganizationsByOrgIdAssociateOfficialTeamsError,
    Options<PostOrganizationsByOrgIdAssociateOfficialTeamsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postOrganizationsByOrgIdAssociateOfficialTeams({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrganizationsByOrgIdDeleteQueryKey = (
  options: Options<PostOrganizationsByOrgIdDeleteData>,
) => [createQueryKey("postOrganizationsByOrgIdDelete", options)];

export const postOrganizationsByOrgIdDeleteOptions = (
  options: Options<PostOrganizationsByOrgIdDeleteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrganizationsByOrgIdDelete({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrganizationsByOrgIdDeleteQueryKey(options),
  });
};

export const postOrganizationsByOrgIdDeleteMutation = (
  options?: Partial<Options<PostOrganizationsByOrgIdDeleteData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostOrganizationsByOrgIdDeleteResponse,
    PostOrganizationsByOrgIdDeleteError,
    Options<PostOrganizationsByOrgIdDeleteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postOrganizationsByOrgIdDelete({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrganizationsByOrgIdVerifyQueryKey = (
  options: Options<PostOrganizationsByOrgIdVerifyData>,
) => [createQueryKey("postOrganizationsByOrgIdVerify", options)];

export const postOrganizationsByOrgIdVerifyOptions = (
  options: Options<PostOrganizationsByOrgIdVerifyData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrganizationsByOrgIdVerify({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrganizationsByOrgIdVerifyQueryKey(options),
  });
};

export const postOrganizationsByOrgIdVerifyMutation = (
  options?: Partial<Options<PostOrganizationsByOrgIdVerifyData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostOrganizationsByOrgIdVerifyResponse,
    PostOrganizationsByOrgIdVerifyError,
    Options<PostOrganizationsByOrgIdVerifyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postOrganizationsByOrgIdVerify({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrganizationsSearchQueryKey = (
  options?: Options<GetOrganizationsSearchData>,
) => [createQueryKey("getOrganizationsSearch", options)];

export const getOrganizationsSearchOptions = (
  options?: Options<GetOrganizationsSearchData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationsSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrganizationsSearchQueryKey(options),
  });
};

export const getOrganizationsQueryKey = (options?: Options) => [
  createQueryKey("getOrganizations", options),
];

export const getOrganizationsOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrganizationsQueryKey(options),
  });
};

export const postOrganizationsCreateQueryKey = (
  options: Options<PostOrganizationsCreateData>,
) => [createQueryKey("postOrganizationsCreate", options)];

export const postOrganizationsCreateOptions = (
  options: Options<PostOrganizationsCreateData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrganizationsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrganizationsCreateQueryKey(options),
  });
};

export const postOrganizationsCreateMutation = (
  options?: Partial<Options<PostOrganizationsCreateData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostOrganizationsCreateResponse,
    PostOrganizationsCreateError,
    Options<PostOrganizationsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postOrganizationsCreate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrganizationsByOrgIdEditQueryKey = (
  options: Options<PostOrganizationsByOrgIdEditData>,
) => [createQueryKey("postOrganizationsByOrgIdEdit", options)];

export const postOrganizationsByOrgIdEditOptions = (
  options: Options<PostOrganizationsByOrgIdEditData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrganizationsByOrgIdEdit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrganizationsByOrgIdEditQueryKey(options),
  });
};

export const postOrganizationsByOrgIdEditMutation = (
  options?: Partial<Options<PostOrganizationsByOrgIdEditData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostOrganizationsByOrgIdEditResponse,
    PostOrganizationsByOrgIdEditError,
    Options<PostOrganizationsByOrgIdEditData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postOrganizationsByOrgIdEdit({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrganizationsByOrgIdBillingPaymentMethodQueryKey = (
  options: Options<GetOrganizationsByOrgIdBillingPaymentMethodData>,
) => [createQueryKey("getOrganizationsByOrgIdBillingPaymentMethod", options)];

export const getOrganizationsByOrgIdBillingPaymentMethodOptions = (
  options: Options<GetOrganizationsByOrgIdBillingPaymentMethodData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationsByOrgIdBillingPaymentMethod({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrganizationsByOrgIdBillingPaymentMethodQueryKey(options),
  });
};

export const postOrganizationsByOrgIdBillingPaymentMethodQueryKey = (
  options: Options<PostOrganizationsByOrgIdBillingPaymentMethodData>,
) => [createQueryKey("postOrganizationsByOrgIdBillingPaymentMethod", options)];

export const postOrganizationsByOrgIdBillingPaymentMethodOptions = (
  options: Options<PostOrganizationsByOrgIdBillingPaymentMethodData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrganizationsByOrgIdBillingPaymentMethod({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrganizationsByOrgIdBillingPaymentMethodQueryKey(options),
  });
};

export const postOrganizationsByOrgIdBillingPaymentMethodMutation = (
  options?: Partial<Options<PostOrganizationsByOrgIdBillingPaymentMethodData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostOrganizationsByOrgIdBillingPaymentMethodResponse,
    PostOrganizationsByOrgIdBillingPaymentMethodError,
    Options<PostOrganizationsByOrgIdBillingPaymentMethodData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postOrganizationsByOrgIdBillingPaymentMethod({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrganizationsByOrgIdBillingSetupIntentQueryKey = (
  options: Options<PostOrganizationsByOrgIdBillingSetupIntentData>,
) => [createQueryKey("postOrganizationsByOrgIdBillingSetupIntent", options)];

export const postOrganizationsByOrgIdBillingSetupIntentOptions = (
  options: Options<PostOrganizationsByOrgIdBillingSetupIntentData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrganizationsByOrgIdBillingSetupIntent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrganizationsByOrgIdBillingSetupIntentQueryKey(options),
  });
};

export const postOrganizationsByOrgIdBillingSetupIntentMutation = (
  options?: Partial<Options<PostOrganizationsByOrgIdBillingSetupIntentData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostOrganizationsByOrgIdBillingSetupIntentResponse,
    PostOrganizationsByOrgIdBillingSetupIntentError,
    Options<PostOrganizationsByOrgIdBillingSetupIntentData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postOrganizationsByOrgIdBillingSetupIntent({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrganizationsByOrgIdPlayersByPlayerIdDeleteQueryKey = (
  options: Options<PostOrganizationsByOrgIdPlayersByPlayerIdDeleteData>,
) => [
  createQueryKey("postOrganizationsByOrgIdPlayersByPlayerIdDelete", options),
];

export const postOrganizationsByOrgIdPlayersByPlayerIdDeleteOptions = (
  options: Options<PostOrganizationsByOrgIdPlayersByPlayerIdDeleteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrganizationsByOrgIdPlayersByPlayerIdDelete({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrganizationsByOrgIdPlayersByPlayerIdDeleteQueryKey(options),
  });
};

export const postOrganizationsByOrgIdPlayersByPlayerIdDeleteMutation = (
  options?: Partial<
    Options<PostOrganizationsByOrgIdPlayersByPlayerIdDeleteData>
  >,
) => {
  const mutationOptions: UseMutationOptions<
    PostOrganizationsByOrgIdPlayersByPlayerIdDeleteResponse,
    PostOrganizationsByOrgIdPlayersByPlayerIdDeleteError,
    Options<PostOrganizationsByOrgIdPlayersByPlayerIdDeleteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postOrganizationsByOrgIdPlayersByPlayerIdDelete({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postUsersInvitationsCreateQueryKey = (
  options: Options<PostUsersInvitationsCreateData>,
) => [createQueryKey("postUsersInvitationsCreate", options)];

export const postUsersInvitationsCreateOptions = (
  options: Options<PostUsersInvitationsCreateData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postUsersInvitationsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postUsersInvitationsCreateQueryKey(options),
  });
};

export const postUsersInvitationsCreateMutation = (
  options?: Partial<Options<PostUsersInvitationsCreateData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostUsersInvitationsCreateResponse,
    PostUsersInvitationsCreateError,
    Options<PostUsersInvitationsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postUsersInvitationsCreate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getUsersInvitationsByTokenCodeQueryKey = (
  options: Options<GetUsersInvitationsByTokenCodeData>,
) => [createQueryKey("getUsersInvitationsByTokenCode", options)];

export const getUsersInvitationsByTokenCodeOptions = (
  options: Options<GetUsersInvitationsByTokenCodeData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUsersInvitationsByTokenCode({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUsersInvitationsByTokenCodeQueryKey(options),
  });
};

export const postUsersInvitationsByTokenCodeRedeemQueryKey = (
  options: Options<PostUsersInvitationsByTokenCodeRedeemData>,
) => [createQueryKey("postUsersInvitationsByTokenCodeRedeem", options)];

export const postUsersInvitationsByTokenCodeRedeemOptions = (
  options: Options<PostUsersInvitationsByTokenCodeRedeemData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postUsersInvitationsByTokenCodeRedeem({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postUsersInvitationsByTokenCodeRedeemQueryKey(options),
  });
};

export const postUsersInvitationsByTokenCodeRedeemMutation = (
  options?: Partial<Options<PostUsersInvitationsByTokenCodeRedeemData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostUsersInvitationsByTokenCodeRedeemResponse,
    PostUsersInvitationsByTokenCodeRedeemError,
    Options<PostUsersInvitationsByTokenCodeRedeemData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postUsersInvitationsByTokenCodeRedeem({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getInvitationsOrganizationsUnverifiedQueryKey = (
  options?: Options,
) => [createQueryKey("getInvitationsOrganizationsUnverified", options)];

export const getInvitationsOrganizationsUnverifiedOptions = (
  options?: Options,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInvitationsOrganizationsUnverified({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInvitationsOrganizationsUnverifiedQueryKey(options),
  });
};

export const postRostersByRosterIdPlayersQueryKey = (
  options: Options<PostRostersByRosterIdPlayersData>,
) => [createQueryKey("postRostersByRosterIdPlayers", options)];

export const postRostersByRosterIdPlayersOptions = (
  options: Options<PostRostersByRosterIdPlayersData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postRostersByRosterIdPlayers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postRostersByRosterIdPlayersQueryKey(options),
  });
};

export const postRostersByRosterIdPlayersMutation = (
  options?: Partial<Options<PostRostersByRosterIdPlayersData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostRostersByRosterIdPlayersResponse,
    PostRostersByRosterIdPlayersError,
    Options<PostRostersByRosterIdPlayersData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postRostersByRosterIdPlayers({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrganizationsByOrgIdPlayersByPlayerExternalIdEditQueryKey = (
  options: Options<PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditData>,
) => [
  createQueryKey(
    "postOrganizationsByOrgIdPlayersByPlayerExternalIdEdit",
    options,
  ),
];

export const postOrganizationsByOrgIdPlayersByPlayerExternalIdEditOptions = (
  options: Options<PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await postOrganizationsByOrgIdPlayersByPlayerExternalIdEdit({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      postOrganizationsByOrgIdPlayersByPlayerExternalIdEditQueryKey(options),
  });
};

export const postOrganizationsByOrgIdPlayersByPlayerExternalIdEditMutation = (
  options?: Partial<
    Options<PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditData>
  >,
) => {
  const mutationOptions: UseMutationOptions<
    PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditResponse,
    PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditError,
    Options<PostOrganizationsByOrgIdPlayersByPlayerExternalIdEditData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } =
        await postOrganizationsByOrgIdPlayersByPlayerExternalIdEdit({
          ...options,
          ...localOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const getAuthoritiesPublicQueryKey = (options?: Options) => [
  createQueryKey("getAuthoritiesPublic", options),
];

export const getAuthoritiesPublicOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAuthoritiesPublic({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAuthoritiesPublicQueryKey(options),
  });
};

export const getTeamsByTeamExternalIdLeaderboardQueryKey = (
  options: Options<GetTeamsByTeamExternalIdLeaderboardData>,
) => [createQueryKey("getTeamsByTeamExternalIdLeaderboard", options)];

export const getTeamsByTeamExternalIdLeaderboardOptions = (
  options: Options<GetTeamsByTeamExternalIdLeaderboardData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTeamsByTeamExternalIdLeaderboard({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTeamsByTeamExternalIdLeaderboardQueryKey(options),
  });
};

export const postBalltrackerByMachineUuidChallengeQueryKey = (
  options: Options<PostBalltrackerByMachineUuidChallengeData>,
) => [createQueryKey("postBalltrackerByMachineUuidChallenge", options)];

export const postBalltrackerByMachineUuidChallengeOptions = (
  options: Options<PostBalltrackerByMachineUuidChallengeData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postBalltrackerByMachineUuidChallenge({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postBalltrackerByMachineUuidChallengeQueryKey(options),
  });
};

export const postBalltrackerByMachineUuidChallengeMutation = (
  options?: Partial<Options<PostBalltrackerByMachineUuidChallengeData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostBalltrackerByMachineUuidChallengeResponse,
    PostBalltrackerByMachineUuidChallengeError,
    Options<PostBalltrackerByMachineUuidChallengeData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postBalltrackerByMachineUuidChallenge({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getBalltrackerByMachineUuidBlockedQueryKey = (
  options: Options<GetBalltrackerByMachineUuidBlockedData>,
) => [createQueryKey("getBalltrackerByMachineUuidBlocked", options)];

export const getBalltrackerByMachineUuidBlockedOptions = (
  options: Options<GetBalltrackerByMachineUuidBlockedData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBalltrackerByMachineUuidBlocked({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBalltrackerByMachineUuidBlockedQueryKey(options),
  });
};

export const postBalltrackerByMachineUuidBlockedQueryKey = (
  options: Options<PostBalltrackerByMachineUuidBlockedData>,
) => [createQueryKey("postBalltrackerByMachineUuidBlocked", options)];

export const postBalltrackerByMachineUuidBlockedOptions = (
  options: Options<PostBalltrackerByMachineUuidBlockedData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postBalltrackerByMachineUuidBlocked({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postBalltrackerByMachineUuidBlockedQueryKey(options),
  });
};

export const postBalltrackerByMachineUuidBlockedMutation = (
  options?: Partial<Options<PostBalltrackerByMachineUuidBlockedData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostBalltrackerByMachineUuidBlockedResponse,
    PostBalltrackerByMachineUuidBlockedError,
    Options<PostBalltrackerByMachineUuidBlockedData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postBalltrackerByMachineUuidBlocked({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteBalltrackerByMachineUuidBlockedMutation = (
  options?: Partial<Options<DeleteBalltrackerByMachineUuidBlockedData>>,
) => {
  const mutationOptions: UseMutationOptions<
    DeleteBalltrackerByMachineUuidBlockedResponse,
    DeleteBalltrackerByMachineUuidBlockedError,
    Options<DeleteBalltrackerByMachineUuidBlockedData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteBalltrackerByMachineUuidBlocked({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getBalltrackerByMachineUuidStatTrackingQueryKey = (
  options: Options<GetBalltrackerByMachineUuidStatTrackingData>,
) => [createQueryKey("getBalltrackerByMachineUuidStatTracking", options)];

export const getBalltrackerByMachineUuidStatTrackingOptions = (
  options: Options<GetBalltrackerByMachineUuidStatTrackingData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBalltrackerByMachineUuidStatTracking({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBalltrackerByMachineUuidStatTrackingQueryKey(options),
  });
};

export const postBalltrackerByMachineUuidStatTrackingQueryKey = (
  options: Options<PostBalltrackerByMachineUuidStatTrackingData>,
) => [createQueryKey("postBalltrackerByMachineUuidStatTracking", options)];

export const postBalltrackerByMachineUuidStatTrackingOptions = (
  options: Options<PostBalltrackerByMachineUuidStatTrackingData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postBalltrackerByMachineUuidStatTracking({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postBalltrackerByMachineUuidStatTrackingQueryKey(options),
  });
};

export const postBalltrackerByMachineUuidStatTrackingMutation = (
  options?: Partial<Options<PostBalltrackerByMachineUuidStatTrackingData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostBalltrackerByMachineUuidStatTrackingResponse,
    PostBalltrackerByMachineUuidStatTrackingError,
    Options<PostBalltrackerByMachineUuidStatTrackingData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postBalltrackerByMachineUuidStatTracking({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteBalltrackerByMachineUuidStatTrackingMutation = (
  options?: Partial<Options<DeleteBalltrackerByMachineUuidStatTrackingData>>,
) => {
  const mutationOptions: UseMutationOptions<
    DeleteBalltrackerByMachineUuidStatTrackingResponse,
    DeleteBalltrackerByMachineUuidStatTrackingError,
    Options<DeleteBalltrackerByMachineUuidStatTrackingData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteBalltrackerByMachineUuidStatTracking({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getBalltrackerByMachineUuidUmpireAssistQueryKey = (
  options: Options<GetBalltrackerByMachineUuidUmpireAssistData>,
) => [createQueryKey("getBalltrackerByMachineUuidUmpireAssist", options)];

export const getBalltrackerByMachineUuidUmpireAssistOptions = (
  options: Options<GetBalltrackerByMachineUuidUmpireAssistData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBalltrackerByMachineUuidUmpireAssist({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBalltrackerByMachineUuidUmpireAssistQueryKey(options),
  });
};

export const postBalltrackerByMachineUuidUmpireAssistQueryKey = (
  options: Options<PostBalltrackerByMachineUuidUmpireAssistData>,
) => [createQueryKey("postBalltrackerByMachineUuidUmpireAssist", options)];

export const postBalltrackerByMachineUuidUmpireAssistOptions = (
  options: Options<PostBalltrackerByMachineUuidUmpireAssistData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postBalltrackerByMachineUuidUmpireAssist({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postBalltrackerByMachineUuidUmpireAssistQueryKey(options),
  });
};

export const postBalltrackerByMachineUuidUmpireAssistMutation = (
  options?: Partial<Options<PostBalltrackerByMachineUuidUmpireAssistData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostBalltrackerByMachineUuidUmpireAssistResponse,
    PostBalltrackerByMachineUuidUmpireAssistError,
    Options<PostBalltrackerByMachineUuidUmpireAssistData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postBalltrackerByMachineUuidUmpireAssist({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteBalltrackerByMachineUuidUmpireAssistMutation = (
  options?: Partial<Options<DeleteBalltrackerByMachineUuidUmpireAssistData>>,
) => {
  const mutationOptions: UseMutationOptions<
    DeleteBalltrackerByMachineUuidUmpireAssistResponse,
    DeleteBalltrackerByMachineUuidUmpireAssistError,
    Options<DeleteBalltrackerByMachineUuidUmpireAssistData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteBalltrackerByMachineUuidUmpireAssist({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getBalltrackerByMachineUuidUnifiedQueryKey = (
  options: Options<GetBalltrackerByMachineUuidUnifiedData>,
) => [createQueryKey("getBalltrackerByMachineUuidUnified", options)];

export const getBalltrackerByMachineUuidUnifiedOptions = (
  options: Options<GetBalltrackerByMachineUuidUnifiedData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBalltrackerByMachineUuidUnified({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBalltrackerByMachineUuidUnifiedQueryKey(options),
  });
};

export const postBalltrackerByMachineUuidUnifiedQueryKey = (
  options: Options<PostBalltrackerByMachineUuidUnifiedData>,
) => [createQueryKey("postBalltrackerByMachineUuidUnified", options)];

export const postBalltrackerByMachineUuidUnifiedOptions = (
  options: Options<PostBalltrackerByMachineUuidUnifiedData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postBalltrackerByMachineUuidUnified({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postBalltrackerByMachineUuidUnifiedQueryKey(options),
  });
};

export const postBalltrackerByMachineUuidUnifiedMutation = (
  options?: Partial<Options<PostBalltrackerByMachineUuidUnifiedData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostBalltrackerByMachineUuidUnifiedResponse,
    PostBalltrackerByMachineUuidUnifiedError,
    Options<PostBalltrackerByMachineUuidUnifiedData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postBalltrackerByMachineUuidUnified({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getBalltrackerByMachineUuidStrikeZoneQueryKey = (
  options: Options<GetBalltrackerByMachineUuidStrikeZoneData>,
) => [createQueryKey("getBalltrackerByMachineUuidStrikeZone", options)];

export const getBalltrackerByMachineUuidStrikeZoneOptions = (
  options: Options<GetBalltrackerByMachineUuidStrikeZoneData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBalltrackerByMachineUuidStrikeZone({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBalltrackerByMachineUuidStrikeZoneQueryKey(options),
  });
};

export const postBalltrackerByMachineUuidStrikeZoneQueryKey = (
  options: Options<PostBalltrackerByMachineUuidStrikeZoneData>,
) => [createQueryKey("postBalltrackerByMachineUuidStrikeZone", options)];

export const postBalltrackerByMachineUuidStrikeZoneOptions = (
  options: Options<PostBalltrackerByMachineUuidStrikeZoneData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postBalltrackerByMachineUuidStrikeZone({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postBalltrackerByMachineUuidStrikeZoneQueryKey(options),
  });
};

export const postBalltrackerByMachineUuidStrikeZoneMutation = (
  options?: Partial<Options<PostBalltrackerByMachineUuidStrikeZoneData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostBalltrackerByMachineUuidStrikeZoneResponse,
    PostBalltrackerByMachineUuidStrikeZoneError,
    Options<PostBalltrackerByMachineUuidStrikeZoneData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postBalltrackerByMachineUuidStrikeZone({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getBalltrackerStrikeZoneBySportQueryKey = (
  options: Options<GetBalltrackerStrikeZoneBySportData>,
) => [createQueryKey("getBalltrackerStrikeZoneBySport", options)];

export const getBalltrackerStrikeZoneBySportOptions = (
  options: Options<GetBalltrackerStrikeZoneBySportData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBalltrackerStrikeZoneBySport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBalltrackerStrikeZoneBySportQueryKey(options),
  });
};

export const getScheduleQueryKey = (options?: Options<GetScheduleData>) => [
  createQueryKey("getSchedule", options),
];

export const getScheduleOptions = (options?: Options<GetScheduleData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSchedule({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getScheduleQueryKey(options),
  });
};

export const getScheduleByScheduleUuidQueryKey = (
  options: Options<GetScheduleByScheduleUuidData>,
) => [createQueryKey("getScheduleByScheduleUuid", options)];

export const getScheduleByScheduleUuidOptions = (
  options: Options<GetScheduleByScheduleUuidData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getScheduleByScheduleUuid({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getScheduleByScheduleUuidQueryKey(options),
  });
};

export const postScheduleExternalQueryKey = (
  options: Options<PostScheduleExternalData>,
) => [createQueryKey("postScheduleExternal", options)];

export const postScheduleExternalOptions = (
  options: Options<PostScheduleExternalData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postScheduleExternal({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postScheduleExternalQueryKey(options),
  });
};

export const postScheduleExternalMutation = (
  options?: Partial<Options<PostScheduleExternalData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostScheduleExternalResponse,
    PostScheduleExternalError,
    Options<PostScheduleExternalData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postScheduleExternal({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postScheduleInternalQueryKey = (
  options: Options<PostScheduleInternalData>,
) => [createQueryKey("postScheduleInternal", options)];

export const postScheduleInternalOptions = (
  options: Options<PostScheduleInternalData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postScheduleInternal({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postScheduleInternalQueryKey(options),
  });
};

export const postScheduleInternalMutation = (
  options?: Partial<Options<PostScheduleInternalData>>,
) => {
  const mutationOptions: UseMutationOptions<
    PostScheduleInternalResponse,
    PostScheduleInternalError,
    Options<PostScheduleInternalData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await postScheduleInternal({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
